import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Connects to data-controller="modal"
export default class extends Controller {
  connect() {
    this.open();
  }

  open() {
    this.modal = new Modal(this.element)
    this.modal.show()
  }

  close() {
    this.element.parentElement.removeAttribute("src")
    this.element.remove()
  }
}
